import React from 'react';
import fdicLogo from '../../assets/images/fdic-logo.png';

const FdicBanner = () => (
  <div className="gn-fdic-banner" role="note" aria-label="FDIC insurance notice">
    <div className="gn-container gn-fdic-banner__inner">
      <img
        src={fdicLogo}
        alt="Equal Housing Lender. Member FDIC."
        className="gn-fdic-banner__logo"
      />
      <p className="gn-fdic-banner__text">
        FDIC-Insured - Backed by the full faith and credit of the U.S. Government
      </p>
    </div>
  </div>
);

export default FdicBanner;
